<template>
  <b-form>
    <b-button v-if="item.clientName" block variant="danger" class="mb-1" @click.stop.prevent="showAll">Показать всех
      клиентов
    </b-button>
    <b-card border-variant="primary" header-border-variant="primary"
            header-bg-variant="light"
            header-text-variant="dark" header-class="text-center">
      <h5 v-if="item.clientName" slot="header">
        {{ item.clientName }}
      </h5>
      <b-card-text>
        <b-alert show variant="warning">
          <b-row>
            <b-col>
              <b-form-group
                  id="fieldset-height"
                  label="Рост"
                  description="от 140 до 220 см"
                  label-for="input-height">
                <b-input-group>
                  <b-form-input id="input-height" type="text" v-model="data.height"
                                trim></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                  id="fieldset-weight"
                  label="Вес"
                  description="от 40 до 130 кг"
                  label-for="input-weight">
                <b-input-group>
                  <b-form-input id="input-weight" type="text" v-model="data.weight"
                                trim></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                  id="fieldset-age"
                  label="Возраст"
                  description="от 12 до 100 лет"
                  label-for="input-age">
                <b-input-group>
                  <b-form-input id="input-age" type="text" v-model="data.age"
                                trim></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-alert>
        <b-alert show variant="primary">
          <b-row>
            <b-col>
              <b-form-group
                  id="fieldset-bpsys"
                  label="Систолическое артериальное давление"
                  description="от 50 до 220 мм рт.ст."
                  label-for="input-bpsys">
                <b-input-group>
                  <b-form-input id="input-bpsys" type="text" v-model="data.bpsys"
                                trim></b-form-input>
                  <b-button id="popover-input-bpsys" variant="outline-info">i</b-button>
                  <b-popover target="popover-input-bpsys" placement="top" title="Как измерить?"
                             triggers="hover"
                             content="В покое, с помощью аппарата для измерения артериального давления на левом плече."></b-popover>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                  id="fieldset-bpdia"
                  label="Диастолическое артериальное давление"
                  description="от 10 до 130 мм рт.ст."
                  label-for="input-bpdia">
                <b-input-group>
                  <b-form-input id="input-bpdia" type="text" v-model="data.bpdia"
                                trim></b-form-input>
                  <b-button id="popover-input-bpdia" variant="outline-info">i</b-button>
                  <b-popover target="popover-input-bpdia" placement="top" title="Как измерить?"
                             triggers="hover"
                             content="В покое, с помощью аппарата для измерения артериального давления на левом плече."></b-popover>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-alert>
        <b-alert show variant="info">
          <b-row>
            <b-col>
              <b-form-group
                  id="fieldset-hr"
                  label="Пульс"
                  description="от 40 до 140 уд/мин"
                  label-for="input-hr">
                <b-input-group>
                  <b-form-input id="input-hr" type="text" v-model="data.hr"
                                trim></b-form-input>
                  <b-button id="popover-input-hr" variant="outline-info">i</b-button>
                  <b-popover target="popover-input-hr" placement="top" title="Как измерить?"
                             triggers="hover"
                             content="В покое, вручную за 1 минуту, либо с помощью пульсометра."></b-popover>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                  id="fieldset-rr"
                  label="Дыхание или ПСВ"
                  description="от 4 до 28 вдох/мин или от 100 до 900 л/мин"
                  label-for="input-rr">
                <b-input-group>
                  <b-form-input id="input-rr" type="text" v-model="data.rr"
                                trim></b-form-input>
                  <b-button id="popover-input-rr" variant="outline-info">i</b-button>
                  <b-popover target="popover-input-rr" placement="top" title="Как измерить?"
                             triggers="hover"
                             content="В покое подсчитывается количество вдохов за 1 минуту или пикфлоуметром пиковая скорость выдоха"></b-popover>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-alert>
        <b-button :disabled="!calculateEnable" block variant="danger" @click.stop.prevent="calculate">
          Рассчитать
          <template v-if="remainCount !== -1">
            <b-badge v-if="remainCount === 0" variant="light">{{ remainCount }}</b-badge>
            <b-badge v-else-if="calculateEnable" variant="light">{{ remainCount }}</b-badge>
            <b-spinner v-else small type="grow"/>
          </template>
        </b-button>
      </b-card-text>
    </b-card>
    <br/>
    <b-card v-if="diagnosisTable.out" border-variant="primary" header-border-variant="primary"
            header-bg-variant="light"
            header-text-variant="dark" header-class="text-center">
      <DiagnosisTable :item="diagnosisTable"/>
      <b-button v-if="item.clientName" block variant="danger" :disabled="!recalculated" @click.stop.prevent="addToChart"
                class="mt-2">
        Добавить в базу
      </b-button>
    </b-card>
    <b-card v-else-if="!calculateEnable && item.clientName" border-variant="primary" header-border-variant="primary"
            header-bg-variant="light"
            header-text-variant="dark" header-class="text-center">
      <div class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
      </div>
    </b-card>
    <br/>
  </b-form>
</template>

<script>
import axios from 'axios';
import DiagnosisTable from './DiagnosisTable.vue'

export default {
  components: {
    DiagnosisTable,
  },
  props: {
    authorizationToken: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
    },
  },
  created: function () {
    axios.defaults.baseURL = 'https://l01s75qla5.execute-api.us-east-1.amazonaws.com/prod';
    axios.defaults.headers.common['Authorization'] = this.authorizationToken;
    if (this.item.clientName) {
      this.readOnce();
    }
    this.readRemainCount();
  },
  data() {
    return {
      data: {
        site: this.item.site,
        clientLogin: this.item.id,
        clientName: this.item.clientName,
        height: 178,
        weight: 74,
        age: 35,
        bpsys: 120,
        bpdia: 75,
        hr: 68,
        rr: 16,
      },
      diagnosisTable: {},
      calculateEnable: false,
      recalculated: false,
      remainCount: -1,
    }
  },
  methods: {
    showAll() {
      this.$emit('showAll');
    },
    mergeData(data) {
      for (let [key] of Object.entries(this.data)) {
        if (data.hasOwnProperty(key)) {
          this.data[key] = data[key];
        }
      }
      this.data.out = data.out;
      this.diagnosisTable = Object.assign({}, this.diagnosisTable, data);
    },
    readOnce() {
      let data = this.data;
      this.data = {};
      let vm = this;
      axios.post('/cyberanalysis', {
        site: this.item.site,
        clientLogin: this.item.id,
      }).then(function (response) {
        vm.data = data;
        if (response.data.length > 0) {
          vm.mergeData(response.data[0]);
        }
        vm.data.site = vm.item.site;
      }).catch(function () {
        vm.data = data;
      });
    },
    readRemainCount() {
      let vm = this;
      this.calculateEnable = false;
      axios.post('/remains', {}).then(function (response) {
        vm.remainCount = response.data.remainCount;
        vm.calculateEnable = (vm.remainCount > 0 || vm.remainCount === -1);
      }).catch(function () {
        vm.calculateEnable = false;
      });
    },
    calculate() {
      let vm = this;
      this.calculateEnable = false;
      this.recalculated = false;
      this.diagnosisTable.out = null;
      axios.post('/cyber1base', this.data).then(function (response) {
        vm.mergeData(response.data);
        vm.remainCount = response.data.remainCount;
        vm.calculateEnable = (vm.remainCount > 0 || vm.remainCount === -1);
        vm.recalculated = true;
      }).catch(function () {
        vm.recalculated = false;
      });
    },
    addToChart() {
      let vm = this;
      this.recalculated = false;
      axios.post('/cyberanalysis', {
        site: this.item.site,
        clientLogin: this.item.id,
        displayAtChart: true,
      }).then(() => {
        vm.recalculated = false;
      }).catch(() => {
        vm.recalculated = true;
      });
    }
  }
}
</script>